import { get, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getInventoryAuditLog = get('inventory.auditLog');

export const getAll = createSelector(getInventoryAuditLog, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getOrderedAuditLogs = createSelector(
  getAllValues,
  orderBy('id', 'desc')
);

export const getIsFetching = createSelector(
  getInventoryAuditLog,
  get('fetching')
);
export const getIsFetched = createSelector(
  getInventoryAuditLog,
  get('fetched')
);
export const getFetchingError = createSelector(
  getInventoryAuditLog,
  get('fetchingError')
);
